import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email || !formData.phone || !formData.subject || !formData.message) {
      setSubmitMessage('يرجى ملء جميع الحقول المطلوبة');
      return;
    }

    if (formData.message.length > 500) {
      setSubmitMessage('الرسالة يجب ألا تتجاوز 500 حرف');
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formDataToSend = new URLSearchParams();
      formDataToSend.append('name', formData.name);
      formDataToSend.append('email', formData.email);
      formDataToSend.append('phone', formData.phone);
      formDataToSend.append('subject', formData.subject);
      formDataToSend.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d5el0lb07s2llnhdb500', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend.toString(),
      });

      if (response.ok) {
        setSubmitMessage('تم إرسال رسالتك بنجاح! سنتواصل معك قريباً');
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: '',
        });
      } else {
        setSubmitMessage('حدث خطأ، يرجى المحاولة مرة أخرى');
      }
    } catch (error) {
      setSubmitMessage('حدث خطأ، يرجى المحاولة مرة أخرى');
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setSubmitMessage(''), 5000);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-dark-navy via-[#0D1128] to-dark-navy font-cairo">
      <div className="fixed inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgwLDIxNywyNTUsMC4wNSkiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-30 pointer-events-none"></div>
      
      <Navbar />

      <main className="relative">
        {/* Hero Section */}
        <section className="pt-32 pb-16 px-6">
          <div className="container mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              نحن هنا للإجابة
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              تواصل معنا للاستفسار عن فرص الاستثمار أو لأي أسئلة أخرى
            </p>
          </div>
        </section>

        {/* Contact Cards */}
        <section className="py-16 px-6">
          <div className="container mx-auto max-w-5xl">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-cyan/30 rounded-2xl p-8 text-center hover:shadow-lg hover:shadow-neon-cyan/20 transition-all duration-300">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-neon-cyan/10 rounded-full">
                  <i className="ri-map-pin-line text-4xl text-neon-cyan"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-3">العنوان</h3>
                <p className="text-gray-400 leading-relaxed">
                  الرياض<br />
                  المملكة العربية السعودية
                </p>
              </div>

              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-cyan/30 rounded-2xl p-8 text-center hover:shadow-lg hover:shadow-neon-cyan/20 transition-all duration-300">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-neon-cyan/10 rounded-full">
                  <i className="ri-mail-line text-4xl text-neon-cyan"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-3">البريد الإلكتروني</h3>
                <p className="text-gray-400 leading-relaxed">
                  info@tayyibat-medical.com
                </p>
              </div>

              <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-neon-cyan/30 rounded-2xl p-8 text-center hover:shadow-lg hover:shadow-neon-cyan/20 transition-all duration-300">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-neon-cyan/10 rounded-full">
                  <i className="ri-phone-line text-4xl text-neon-cyan"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-3">الهاتف</h3>
                <p className="text-gray-400 leading-relaxed">
                  +966 XX XXX XXXX
                </p>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-gradient-to-br from-dark-card to-dark-navy border border-gray-700/50 rounded-2xl p-8 md:p-12">
              <h2 className="text-3xl font-bold text-white mb-6 text-center">أرسل لنا رسالة</h2>
              
              <form onSubmit={handleSubmit} data-readdy-form id="contact_form" className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="name" className="block text-white font-semibold mb-2">
                      الاسم الكامل <span className="text-red-400">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="w-full px-4 py-3 bg-dark-navy border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-neon-cyan transition-colors"
                      required
                    />
                  </div>

                  <div>
                    <label htmlFor="email" className="block text-white font-semibold mb-2">
                      البريد الإلكتروني <span className="text-red-400">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full px-4 py-3 bg-dark-navy border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-neon-cyan transition-colors"
                      required
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="phone" className="block text-white font-semibold mb-2">
                      رقم الهاتف <span className="text-red-400">*</span>
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full px-4 py-3 bg-dark-navy border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-neon-cyan transition-colors"
                      required
                    />
                  </div>

                  <div>
                    <label htmlFor="subject" className="block text-white font-semibold mb-2">
                      الموضوع <span className="text-red-400">*</span>
                    </label>
                    <select
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      className="w-full px-4 py-3 bg-dark-navy border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-neon-cyan transition-colors cursor-pointer"
                      required
                    >
                      <option value="">اختر الموضوع</option>
                      <option value="investment">استفسار عن الاستثمار</option>
                      <option value="partnership">فرص الشراكة</option>
                      <option value="general">استفسار عام</option>
                      <option value="support">الدعم الفني</option>
                    </select>
                  </div>
                </div>

                <div>
                  <label htmlFor="message" className="block text-white font-semibold mb-2">
                    الرسالة <span className="text-red-400">*</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows={6}
                    maxLength={500}
                    className="w-full px-4 py-3 bg-dark-navy border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-neon-cyan transition-colors resize-none"
                    required
                  ></textarea>
                  <p className="text-sm text-gray-500 mt-2">
                    {formData.message.length} / 500 حرف
                  </p>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full px-8 py-4 bg-neon-cyan text-white font-semibold rounded-lg hover:bg-neon-cyan/90 hover:shadow-lg hover:shadow-neon-cyan/30 transition-all duration-300 whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isSubmitting ? 'جاري الإرسال...' : 'إرسال الرسالة'}
                </button>

                {submitMessage && (
                  <div className={`p-4 rounded-lg text-center ${submitMessage.includes('نجاح') ? 'bg-neon-green/10 border border-neon-green/30 text-neon-green' : 'bg-red-500/10 border border-red-500/30 text-red-400'}`}>
                    {submitMessage}
                  </div>
                )}
              </form>
            </div>

            {/* Info Note */}
            <div className="mt-8 bg-gradient-to-br from-neon-cyan/10 to-transparent border border-neon-cyan/30 rounded-2xl p-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-neon-cyan/20 rounded-full flex-shrink-0">
                  <i className="ri-information-line text-xl text-neon-cyan"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-white mb-2">للمستثمرين الحاليين</h3>
                  <p className="text-gray-400 leading-relaxed">
                    يرجى استخدام لوحة التحكم الخاصة بك للوصول إلى معلومات الاستثمار والتقارير المالية. هذا النموذج مخصص للاستفسارات العامة فقط.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
